<template>
  <ButtonSquareHoverChecklist
    :title="$t('general__data__buildings')"
    :imgSource="iconBuildings"
    size="large"
    :hoverButtons="formattedMapLayers"
    :activeState="active ? 'active' : 'inactive'"
    @clicked="toggleVisible"
    @hovered="$emit('MapFilterButtonHovered')"
    @onChecklistToggle="updateFilteredLayers"
  />
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import ButtonSquareHoverChecklist from '@/components/general/buttons/ButtonSquareHoverChecklist.vue'
import iconBuildings from '@/assets/icons-general/icon-buildings.svg'
import { MAPVIEW_PREFIX } from '@/store/module-prefixes'
import { SET_FILTERED_MAP_LAYERS } from '@/store/mutation-types'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
defineEmits(['MapFilterButtonHovered'])
const store = useStore()
const active = ref(false)

const filteredMapLayers = computed(() => store.state[MAPVIEW_PREFIX].filteredLayers)

const formattedMapLayers = computed(() => {
  return filteredMapLayers.value
    .filter((layer: any) => layer.id === 'building' || layer.id === 'realestates')
    .map((layer: any) => {
      const newLayer = { ...layer }
      if (newLayer.title.startsWith('general__data__filter')) {
        newLayer.title = t(newLayer.title)
      }
      return newLayer
    })
})

function toggleVisible() {
  active.value = !active.value
}

function updateFilteredLayers(id: string | number) {
  const filteredLayers = [...filteredMapLayers.value]
  const index = filteredLayers.findIndex((layer) => layer.id === id)
  if (index === -1) return
  filteredLayers[index].visible = !filteredLayers[index].visible
  store.commit(`${MAPVIEW_PREFIX}/${SET_FILTERED_MAP_LAYERS}`, { filteredLayers })
}
function hideHoverButtons() {
  active.value = false
}

defineExpose({
  hideHoverButtons
})
</script>
